import React from "react";
import "./Overlay.scss";
import quill from "../../images/quill.svg";

const Overlay = () => {
  return (
    <div className="Overlay">
      <h1>
        Dr. Dattatreya Tapkeer <img src={quill} className="quill"></img>
      </h1>
      <h2>A glance towards journey so far</h2>
    </div>
  );
};

export default Overlay;
